module.exports = __webpack_public_path__ + "fonts/gothic-a1-v8-latin-600.040e354d.woff";